import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist/dist/umd'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: 'crf-storage',
  storage: localStorage
})

export const store = new Vuex.Store({
  state: {
    language: Vue.$config.user_settings.language_default,
    dateLocale: Vue.$config.user_settings.date_locale_default,
    dateFormat: Vue.$config.user_settings.date_format_default,
    decimalFormat: Vue.$config.user_settings.decimal_format_default,
    csvDelimmeter: Vue.$config.user_settings.CSV_separator_default
  },
  mutations: {
    language (state, language) {
      state.language = language
      if (language === 'English') {
        state.dateLocale = 'en'
      } else {
        state.dateLocale = 'sr-cyrl'
      }
    },
    dateFormat (state, dateFormat) {
      state.dateFormat = dateFormat
    },
    decimalFormat (state, decimalFormat) {
      state.decimalFormat = decimalFormat
    },
    csvDelimmeter (state, csvDelimmeter) {
      state.csvDelimmeter = csvDelimmeter
    }
  },
  actions: {
    regional ({commit}, payload) {
      return new Promise((resolve, reject) => {
        commit('language', payload.language)
        commit('dateFormat', payload.dateFormat)
        commit('decimalFormat', payload.decimalFormat)
        commit('csvDelimmeter', payload.csvDelimmeter)
        resolve()
      })
    }
  },
  getters: {
    language: state => state.language,
    dateLocale: state => state.dateLocale,
    dateFormat: state => state.dateFormat,
    decimalFormat: state => state.decimalFormat,
    csvDelimmeter: state => state.csvDelimmeter
  },
  plugins: [vuexPersist.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js